export default __webpack_public_path__ + "static/media/Screenshot_6.8c17ccb0.png";